import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { DocumentoObrasService } from "../services/documento-obras.services";

@Injectable({
  providedIn: 'root'
})
export class DocumentoObrasResolver implements Resolve<boolean> {

  constructor(private service: DocumentoObrasService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}


@Injectable({
  providedIn: 'root'
})
export class DocumentoObrasFiltersResolver implements Resolve<boolean> {

  constructor(private service: DocumentoObrasService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getListFilters();
  }
}